module.exports = __webpack_public_path__ + "static/media/sat_logo_title_black.6ad5af54.svg";